/**
 * Set to "true" to open the deposit modal on load. The modal is mounted app
 * wide, so this works from any route.
 *
 * Must match the `depositModal` key on `depositModalParams`, which is what
 * actually reads it. Kept in a leaf module so link builders can reference it
 * without pulling the modal, and the wizard behind it, into their bundle.
 */
export const DEPOSIT_MODAL_PARAM = "depositModal";
